// DEV-357: Reports summary tiles for a broker's book.
// GET /api/employees with no clientId returns the agency's own staff (client_id
// null), not client employees — headcount comes from each client's
// actualEmployeeCount (active employees, computed by GET /api/clients).
// Plans live in the library (plans.client_id null) and are linked to clients
// through client_plans, so plan/carrier counts come from GET /api/clientplans.

type ClientLike = { id: number; actualEmployeeCount?: number | string | null };
type ClientPlanLike = {
  clientId: number;
  planId?: number | null;
  status?: string | null;
  isActive?: boolean | null;
  plan?: { carrierId?: number | null } | null;
};

/** Active employees across the given clients. */
export function sumActiveEmployees(clients: readonly ClientLike[]): number {
  return clients.reduce((sum, c) => sum + (Number(c.actualEmployeeCount) || 0), 0);
}

const isActiveClientPlan = (cp: ClientPlanLike) =>
  cp.isActive !== false && String(cp.status ?? "active").toLowerCase() === "active";

/** Active client-plan links and their distinct carriers, limited to `clientIds` when given. */
export function summarizeActiveClientPlans(
  clientPlans: readonly ClientPlanLike[],
  clientIds?: ReadonlySet<number>,
): { plans: number; carriers: number } {
  const active = clientPlans.filter(
    cp => isActiveClientPlan(cp) && (!clientIds || clientIds.has(cp.clientId)),
  );
  const carriers = new Set(active.map(cp => cp.plan?.carrierId).filter(id => id != null));
  return { plans: active.length, carriers: carriers.size };
}
